import { Box, chakra } from "@chakra-ui/react"

export type SortColumn = "score" | "student_name" | "completed_at"
export type SortDir = "asc" | "desc"

interface SortableHeaderProps {
  label: string
  column: SortColumn
  activeSortBy: SortColumn
  sortDir: SortDir
  onSort: (column: SortColumn) => void
}

export function SortableHeader({
  label,
  column,
  activeSortBy,
  sortDir,
  onSort,
}: SortableHeaderProps) {
  const isActive = activeSortBy === column
  const arrow = isActive ? (sortDir === "asc" ? "▲" : "▼") : ""
  return (
    <Box
      as="th"
      textAlign="left"
      p={4}
      borderBottomWidth="1px"
      fontWeight="semibold"
      aria-sort={
        isActive ? (sortDir === "asc" ? "ascending" : "descending") : "none"
      }
    >
      <chakra.button
        type="button"
        onClick={() => onSort(column)}
        display="inline-flex"
        alignItems="center"
        gap={1}
        cursor="pointer"
        bg="transparent"
        fontWeight="semibold"
      >
        {label}
        {arrow && <Box as="span">{arrow}</Box>}
      </chakra.button>
    </Box>
  )
}
